
import { createI18n } from 'vue-i18n'

import en from "@/locales/en.json"
import fr from "@/locales/fr.json"

export const i18n = createI18n({
    globalInjection: true,
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {
        en,
        fr,
    }
})